// https://tommcfarlin.com/check-if-a-page-is-in-an-iframe/

export default function isInIframe() {
  try {
    return window.location !== window.parent.location
  } catch (_) {
    return false
  }
}
